import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  resolutionInputDiv: {
    display: 'flex',
  },
  visible: {
    display: 'flex',
  },
  hidden: {
    display: 'none',
  },
  icon: {
    marginTop: '2rem',
    width: '1.6rem',
  },
  resolutionErrorShow: {
    display: 'unset',
    color: '#db2e2e',
  },
  resolutionErrorHide: {
    display: 'none',
  },
  inputSelect: {
    userSelect: 'all',
  },
}))

export default useStyles
